import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { of as observableOf } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Group } from '../shared/definitions';
import { AppStore } from '../store/app.store';

@Component({
  selector: 'custom-footer',
  templateUrl: './custom-footer.component.html',
})
export class CustomFooterComponent implements OnInit {
  customCguLink: string;

  constructor(
    private _route: ActivatedRoute,
    private _appStore: AppStore,
  ) {}

  ngOnInit() {
    const masterGroupId: string = this._route.snapshot.params['id'] || this._route.snapshot.queryParams['_'];

    if (masterGroupId) {
      this._appStore
        .load('Group', masterGroupId)
        .entity.pipe(catchError(() => observableOf(null)))
        .subscribe((group: Group | null) => {
          if (!group || !group.options || !group.options['cgu_link']) return;
          this.customCguLink = group.options['cgu_link'];
        });
    }
  }
}
